<script>
import { mapActions, mapGetters } from 'vuex';
import { Field } from 'vee-validate';

import VSelect from '@/components/Common/VSelect';
import VSelectSearch from '@/components/Common/VSelectSearch';
import VInput from '@/components/Common/VInput';

export default {
  name: 'FirstStep',
  components: {
    VSelect,
    VSelectSearch,
    VInput,
    VeeField: Field,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      brands: 'Service/brands',
      models: 'Service/models',
      fetching: 'Service/fetching',
    }),
    customizeBrands() {
      return this.brands
        ? [...this.brands].concat([{ id: 0, name: 'Другая марка' }])
        : this.brands;
    },
    customizeModels() {
      return this.models
        ? [...this.models].concat([{ id: 0, name: 'Другая модель' }])
        : this.models;
    },
  },
  watch: {
    form: {
      handler(value) {
        this.$emit('update-form', value);
      },
      deep: true,
    },
    'form.brand'() {
      this.loadModels({ brand: this.form.brand?.id });
      this.loadDealers({ brand: this.form.brand?.id });
      this.loadServices({ brand: this.form.brand?.id });
      this.$emit('changed-brand');
    },
    models() {
      this.customizeModels = this.models
        ? [...this.models].concat([{ id: 0, name: 'Другая модель' }])
        : this.models;
    },
  },
  methods: {
    ...mapActions({
      loadModels: 'Service/loadModels',
      loadDealers: 'Service/loadDealers',
      loadServices: 'Service/loadServices',
    }),
  },
};
</script>

<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 sm:col-span-2 lg:grid-cols-4 lg:col-span-4 w-full gap-x-5 gap-y-5"
  >
    <vee-field v-slot="{ handleChange, errorMessage }" name="brand">
      <v-select-search
        v-model="form.brand"
        :options="customizeBrands"
        placeholder="Выберите марку"
        inscription="Марка авто*"
        theme="white"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>

    <vee-field v-slot="{ handleChange, errorMessage }" name="model">
      <v-select
        v-model="form.model"
        :options="customizeModels"
        placeholder="Выберите модель"
        inscription="Модель*"
        theme="white"
        :disabled="form.brand === null || form.brand?.exception"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>

    <vee-field v-slot="{ handleChange, errorMessage }" name="name">
      <v-input
        v-model="form.name"
        placeholder="Ваше имя"
        inscription="Имя*"
        theme="white"
        name="name"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>

    <vee-field v-slot="{ handleChange, errorMessage }" name="phone">
      <v-input
        v-model="form.phone"
        format="phone"
        placeholder="+7 (___) ___-__-__"
        inscription="Телефон*"
        theme="white"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>
  </div>
</template>
